import { useEffect, useState } from 'react';

const COUNTRY_CODES = ['+91', '+1', '+44', '+61', '+971', '+65'];

const INITIAL_FORM = {
  name: '',
  email: '',
  countryCode: '+91',
  phone: '',
  requirement: '',
};

export default function EnquiryModal({ open, onClose }) {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState({ type: 'idle', message: '' });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;

    if (open) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [open]);

  useEffect(() => {
    if (!open) {
      setForm(INITIAL_FORM);
      setStatus({ type: 'idle', message: '' });
      setSubmitting(false);
    }
  }, [open]);

  useEffect(() => {
    if (!open) return;

    const handleEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setStatus({ type: 'idle', message: '' });

    try {
      const formData = new FormData();

      formData.append("access_key", "71884507-ec14-452e-b570-fdf0b97bdfae"); // 🔑 your key
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("phone", `${form.countryCode} ${form.phone}`);
      formData.append("requirement", form.requirement);
      formData.append("subject", "New Enquiry from Website");
      formData.append("from_name", form.name);
      formData.append("replyto", form.email);
      formData.append("botcheck", ""); // spam protection

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: 'success',
          message: 'Enquiry sent successfully!',
        });
        setForm(INITIAL_FORM);
      } else {
        throw new Error(data.message || 'Failed to send enquiry');
      }

    } catch (error) {
      setStatus({
        type: 'error',
        message: 'Something went wrong. Try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="enquiry-title">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-card">
        <button type="button" className="modal-close" aria-label="Close form" onClick={onClose}>
          ×
        </button>

        <div className="modal-content">
          <div className="eyebrow">Strategy Enquiry</div>

          <h3 id="enquiry-title" className="modal-title">
            Tell us what you need
          </h3>

          <p className="modal-subtitle">
            Share the basics and we will reply with the right next step for your project.
          </p>

          <form className="enquiry-form" onSubmit={handleSubmit}>
            <input type="checkbox" name="botcheck" style={{ display: "none" }} />

            <label className="form-field">
              <span>Name</span>
              <input
                name="name"
                type="text"
                value={form.name}
                onChange={handleChange}
                placeholder="Your full name"
                required
              />
            </label>

            <label className="form-field">
              <span>Email</span>
              <input
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </label>

            <div className="form-row">
              <label className="form-field form-field-code">
                <span>Code</span>
                <select name="countryCode" value={form.countryCode} onChange={handleChange}>
                  {COUNTRY_CODES.map((code) => (
                    <option key={code} value={code}>
                      {code}
                    </option>
                  ))}
                </select>
              </label>

              <label className="form-field">
                <span>Phone number</span>
                <input
                  name="phone"
                  type="tel"
                  value={form.phone}
                  onChange={handleChange}
                  placeholder="98765 43210"
                  required
                />
              </label>
            </div>

            <label className="form-field">
              <span>Project requirement</span>
              <textarea
                name="requirement"
                value={form.requirement}
                onChange={handleChange}
                rows="4"
                placeholder="Tell us about the website, app, automation, or branding work you need."
                required
              />
            </label>

            {status.message && (
              <div className={`form-status is-${status.type}`}>
                {status.message}
              </div>
            )}

            <button className="btn btn-primary modal-submit" type="submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Enquiry'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}